<template>
  <LmForm ref="lmFormRef">
  <b-row no-gutters id="lm-user-profile" class="wrapper-content w-100">
    <b-col cols="12" class="wrapper-content">
      <b-row class="wrapper-title-page">
        <b-col cols="12" class="d-flex  align-items-center">
          <h4 class="page-title">{{ $t('user_profile_title') }}</h4>
        </b-col>
      </b-row>
      <div class="row">
        <div class="col-12 justify-content-center d-flex">
          <div class="text-center wrapper-avatar">
            <b-avatar
              class="avatar-user"
              size="10rem"
              variant="primary"
              button
              :text="userInitials"
            >
            </b-avatar>
            <h1 class="font-weight-bold mt-3 text-name">{{ username | lmCapitalizeFilter }}</h1>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 justify-content-center d-flex">
        </div>
      </div>
    </b-col>
    <b-col cols="12" class="wrapper-content mt-4">
      <LmButton
        type="button"
        buttonClass="btn-secondary"
        :isProcessing="isFormProcessing"
        :value="$t('Cancel')"
        @click.native="cancelBtn"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
      />
    </b-col>
  </b-row>
  </LmForm>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import commonsApi from '@/api/commons'
import LmButton from '@/components/form/elements/LmButton'
import LmForm from '@/components/form/LmForm.vue'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  computed: {
    ...mapState('session', ['avatar', 'username', 'extra']),
    avatarPhoto: {
      get () {
        return this.avatarPhotoSrc ? this.avatarPhotoSrc : this.avatar
      },
      set (image) {
        this.avatarPhotoSrc = image
      }
    },
    userInitials () {
      if (this.user.firstname && this.user.lastname) {
        return this.user.firstname.charAt(0) + this.user.lastname.charAt(0)
      } else {
        return ''
      }
    }
  },
  data () {
    return {
      user: '',
      avatarPhotoSrc: null,
      isFormProcessing: false
    }
  },
  components: {
    LmForm,
    LmButton
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    ...mapActions('session', ['getUserInfo']),
    cancelBtn () {
      this.$router.go(-1)
    }
  },
  async mounted () {
    this.getUserInfo()
    const getUser = await commonsApi.axiosGetWrapper(`/users/info`)
    this.user = getUser.data
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      document.title = `Perfil ${vm.username} ${vm.$store.getters['settings/appName']} `
    })
  }
}
</script>

<style lang="sass" scoped>
  #lm-user-profile
    .wrapper-avatar
      .avatar-user
        .avatar-user-img
          max-height: 100%
        .camera-icon
          position: absolute
          bottom: 20px
      .text-name
        font-size: 22px

</style>
